import { useLocation } from 'react-router-dom';

import { DEFAULT_OPTIONS_MENU_SIDE, OPTIONS, ROUTES } from './constant';

const useSelectOptionMenuSide = () => {
  const location = useLocation();

  const getOptionsMenuSideByRoute = (route: string): string[] => {
    if (OPTIONS[route as ROUTES]) {
      return OPTIONS[route as ROUTES];
    }

    for (const key in OPTIONS) {
      if (key.includes('/:')) {
        const pattern = '^' + key.replace(/:\w+/g, '[^/]+') + '$';
        const regex = new RegExp(pattern);
        if (regex.test(route)) {
          return OPTIONS[key as ROUTES];
        }
      }
    }

    return DEFAULT_OPTIONS_MENU_SIDE;
  };

  const valueSelectedMenuSide = getOptionsMenuSideByRoute(location.pathname);

  return { valueSelectedMenuSide };
};

export default useSelectOptionMenuSide;
